<template>
  <div class="container-fluid">
    <loading v-if="loadingRender"></loading>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-info"></i> درخواست استرداد سپرده
          <span class="float-left" @click="$router.go(-1)"> <i data-v-9331d9a2="" title="بازگشت به صفحه قبلی" class="fas fa-arrow-left text-light Pointer" style="float: left; font-size: 18px"></i></span>
        </h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-md-2 col-12"></div>
          <div v-if=" ListRequest.length==0 || (ListRequest.length-1>=0 &&ListRequest[ListRequest.length-1].vaziatGrp44!=null)" class="col-md-8 col-12">
            <div class="row">
              <div class="col-12 text-center">
                <h5>
                  {{ $store.state.NameSandogh }}
                </h5>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <h6>
                  {{ 'فرم درخواست استرداد سپرده' }}
                </h6>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right mt-5">
                <h6>
                  {{ 'مدیرعامل محترم شرکت تعاونی اعتبار' }}
                </h6>
                <br />
                <h6>
                  {{ 'با سلام' }}
                </h6>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ 'احتراماً اینجانب' }}</span>
                  </div>
                  <input type="text" disabled v-model="NamFam" class="form-control text-right" aria-label="" />
                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'با کد ملی ' }}</span>
                  </div>
                  <input type="text" disabled v-model="CodeMeli" class="form-control text-left" aria-label="" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="text-wrap: wrap">{{ 'با توجه به سپرده گذاری خويش به مبلغ' }} </span>
                  </div>
                  <input type="text" class="form-control 3ragham text-left" v-model="Mablagh" @keypress="$ValidNumber($event, 11)" />
                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'ريال خواهشمند است دستور فرمائيد ' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ 'مبلغ ' }}</span>
                  </div>
                  <input type="text" class="form-control 3ragham text-left" v-model="MablaghSeporde" @keypress="$ValidNumber($event, 11)" />
                  <div class="input-group-append">
                    <span class="input-group-text">{{ 'ريال از سپرده گذاری اينجانب به شماره حساب' }}</span>
                  </div>
                  <input :disabled="isDisabled" type="number" v-model="ShomareHesab" class="form-control text-left" aria-label="" />
                  <div class="input-group-append">
                    <span class="input-group-text">{{ BnakName }} {{ 'استرداد گردد.' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-1 mt-2"><input type="radio" id="html" name="fav_language" class="Pointer" :value="1" v-model="IsSaveEmtiaz"/></div>
              <div class="col-11 input-group-text">ضمنا خواهشمند است امتياز وام اينجانب ذخيره گردد</div>
              <div class="col-1 mt-3"><input type="radio" id="html" name="fav_language" class="Pointer" :value="2" v-model="IsSaveEmtiaz"/></div>
              <div class="col-11 input-group-text">ضمنا خواهشمند است امتياز وام اينجانب تا تاریخ <date-picker class="mr-2" input-class="ml-2 text-center" :editable="true" :auto-submit="true" color="gray" v-model="TarixEmatiazVam"> </date-picker> محاسبه گردد</div>
            </div>
            <hr />

            <div class="row mt-2">
              <div class="col-12 mt-1 text-center">
                <button @click="question()" class="btn btn-submit w-100 mt-2">ثبت درخواست</button>
              </div>
            </div>
          </div>
          <div class="col-md-8 co-12">
            <div class="row">
              <div v-if="ListRequest.length!=0 && ( ListRequest[ListRequest.length-1].vaziatGrp44==null)" class="alert alert-warning w-100 text-dark font-weight-bold text-right">شما عضو محترم درخواست استرداد سپرده خود را در تاریخ {{ zamanInsert }} ارسال کرده اید و تا زمان تغییر وضعیت مدیر سامانه، امکان ارسال مجدد نمی باشد <span class="badge badge-warning p-2 font-weight-normal"> درحال بررسی </span> </div>
            </div>
          </div>
          <div class="col-md-2 col-12"></div>
        </div>
      </template>
    </net-pa-card>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-info"></i> سوابق درخواست
        </h6>
      </template>
      <template slot="content">
        <div class="container" style="max-height: 420px; overflow-y: scroll ; overflow-x: hidden; ">
          <div class="row p-4">
            <div v-for="(item, index) in ListRequest" :key="index" class="col-12 border mt-4 p-4 bnp-rounded border Netpa-Shadow">
              <div class="row mt-2">
                  <div class="col-12 col-md-3">
                      <span class="text-secondary">تاریخ درخواست </span>
                      <span class="font-weight-bold">
                          {{item.zamanInsert}}
                      </span>
                  </div>
                  <div class="col-12 col-md-3">
                      <span class="text-secondary">شماره حساب </span>
                      <span class="font-weight-bold">
                          {{item.shomareHesab}}
                      </span>
                  </div>
                  <div class="col-12 col-md-3">
                      <span class="text-secondary">مبلغ درخواستی </span>
                      <span class="font-weight-bold">
                          {{$Comma3ragham(item.mablaghSeporde)}}
                      </span>
                  </div>
                  <div class="col-12 col-md-3">
                      <span class="text-secondary">وضعیت درخواست </span>
                      <span class="font-weight-bold">
                        <span class="badge badge-warning px-2 font-weight-normal" v-if="item.vaziatGrp44==null"> در حال بررسی </span>
                        <span class="badge badge-success px-2 font-weight-normal" v-if="item.vaziatGrp44==7190"> تاییـــد شد </span>
                        <span class="badge badge-danger px-2 font-weight-normal" v-if="item.vaziatGrp44==7191"> رد شــــد </span>
                      </span>
                  </div>
              </div>
            </div> 

          </div>
        </div>
      </template>

    </net-pa-card>
    <div class="row"></div>
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import loading from '../Tools/NetPa/Loading.vue'
export default {
  components: { NetPaCard, VueBootstrap4Table, loading },
  data() {
    return {
      loadingRender: false,
      NamFam: '',
      CodeMeli: '',
      ShomareHesab: null,
      MablaghSeporde: '',
      Mablagh: '',
      TarixEmatiazVam: '',
      DataAxios: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'Letter/PostSodorEsterdad',
        Token: this.$session.get('TokenNetPa'),
      },
      IsEnsraf: false,
      zamanInsert: '',
      BnakName: '',
      isDisabled: false,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      IsSaveEmtiaz: 1,
      ListRequest: []     
    }
  },
  updated() {
    this.$PutCommatoInput()
  },
  mounted() {
    this.NamFam = this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily
    this.CodeMeli = this.$session.get('UserInfoNetPa').codeMeli.trim()
    this.TarixEmatiazVam = this.$store.state.JalaliDate
    this.GetData()
  },
  methods: {
    question() {
      if (this.Mablagh == null || this.Mablagh == '' || this.Mablagh <= 0) {
        this.$mySweetDefault('خطا', 'مبلغ سپرده گذاری به صورت صحیح وارد نشده است', 'error', 2500)
        return
      }
      if (this.MablaghSeporde == null || this.MablaghSeporde == '' || this.MablaghSeporde <= 0) {
        this.$mySweetDefault('خطا', 'مبلغ درخواستی به صورت صحیح وارد نشده است', 'error', 2500)
        return
      }
      if (this.ShomareHesab == null || this.ShomareHesab == '') {
        this.$mySweetDefault('خطا', ' شماره حساب وارد نشده است', 'error', 2500)
        return
      }
      // console.log("SSSSSS",this.$Comma3ragham(this.MablaghSeporde));
      
      this.$SweetQustion('اطمینان از  درخواست استرداد سپرده', 'آیا اطمینان دارید از  درخواست استرداد سپرده خود به مبلغ  ' + this.$Comma3ragham(this.MablaghSeporde)  + ' ريال ', 'question', 'تایید ', 'انصراف', this.CodeMeli, this.SendData, this.isNotConfirmed)
    },
    SendData() {
      this.DataAxios.ArryfildValue.NamFam = this.NamFam
      this.DataAxios.ArryfildValue.CodeMeli = this.CodeMeli
      this.DataAxios.ArryfildValue.MablaghSeporde = Number(this.MablaghSeporde.replaceAll(/,/g, ''))
      this.DataAxios.ArryfildValue.ShomareHesab = this.ShomareHesab + ''
      this.DataAxios.ArryfildValue.TarixEmatiazVam =this.IsSaveEmtiaz==1?null:this.TarixEmatiazVam
      this.$PostData(this.DataAxios)
        .then((result) => {
          if (result) {
            this.$mySweetDefaultTost('عملیات موفق', 'درخواست استرداد سپرده شما با موفقیت ثبت گردید', 'success', 4000)
          }
        })
        .finally(() => {
          this.GetData()
        })
    },
    isNotConfirmed() {},
    GetData() {
      this.loadingRender = true
      var formdata = new FormData()
      formdata.append('codemeli', this.CodeMeli)
      var DataAxios_GetData = {
        ArryfildValue: formdata,
        Method: 'Post',
        Action: 'Letter/GetSodorEsterdad',
        Token: this.$session.get('TokenNetPa'),
      }
      this.$PostFormData(DataAxios_GetData)
        .then((data) => {
          if (data.length > 0) {
            this.loadingRender = false
            this.IsEnsraf = true
            this.zamanInsert = data[data.length-1].zamanInsert
            this.ListRequest=data
          } else this.IsEnsraf = false
        })
        .finally(() => {
          this.GetAccount()
        })
    },
    GEtAzaHesab() {
      var formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      var DataAxios = { Method: 'Post', Action: 'SelAzaHesab', ArryfildValue: formData, Token: this.$session.get('TokenNetPa') }
      this.$PostFormData(DataAxios)
        .then((result) => {
          if (result.length > 0) {
            this.loadingRender = false
            var filterd = result.filter((x) => x.active == true)
            // console.log(filterd);
            this.ShomareHesab = filterd[0].hesabNo.trim()
            this.BnakName = 'بانک ' + filterd[0].bankName
            this.isDisabled = true
          }
        })
        .finally(() => {
          this.loadingRender = false
        })
    },
    GetAccount() {
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 2)
      this.DataAxiosRow.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosRow)
        .then((data) => {
          // console.log("😂 ~ data:", data.filter((x) => x.wwwtblNoeId == 58207))
          if (data.length > 0) {
            this.loadingRender = false
            
            // var filter = data.filter((x) => x.wwwtblNoeId == Number(JSON.parse($cookies.get('NoeIdPishFarz')))) /// قرار شد که از سهامداران برداشته بشه  و بشه سپرده اعضا
            var filter = data.filter((x) => x.wwwtblNoeId == 9618569)
            // var filter = data.filter((x) => x.bnpCashDBtblNoeId == 363480)//ایدی سپرده اعضای پایین
            if (filter.length > 0) this.Mablagh = filter[0].mande
          }
        })
        .finally(() => {
          this.GEtAzaHesab()
        })
    },
  },
}
</script>
<style scoped>
input[type='text'],
input[type='number'],
input[type='password'],
textarea,
select {
  outline: none;
}

input {
  background: transparent;
  border: none;
  border-bottom: 1px solid #a3a3a3;
}
.input-group-text {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #000000;
  text-align: center;
  white-space: nowrap;
  background-color: transparent;
  border: none !important;
  border-radius: 0px !important ;
}

.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%, rgba(72, 20, 193, 1) 100%);
}

.btn-submit:hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}
</style>
